// extracted by mini-css-extract-plugin
export default {"MobileMenuModal":"MobileNavigationMenu_MobileMenuModal__e5AI2"};